import React, { MouseEvent } from 'react'
import { Select2 } from '@blueprintjs/select'
import { Checkbox, MenuItem, Position } from '@blueprintjs/core'
import { Button, Flex } from '@ui'
import { IUIButtonProps } from '@ui/buttons/Button'
import api from '@api'
import { get } from 'lodash'

interface CountrySelectProps {
  value: string | null
  btnText?: string
  itemDisabled?: (item: string) => boolean
  onChange: (item: string) => void
  buttonProps?: IUIButtonProps
  multi?: boolean
}

const CountrySelector = Select2<string>

export default function CountrySelect({
  value,
  btnText,
  itemDisabled,
  onChange,
  buttonProps,
  multi,
}: CountrySelectProps) {
  const countries = useCountries()

  return (
    <CountrySelector
      resetOnSelect
      popoverProps={{ minimal: true, position: Position.BOTTOM }}
      filterable={false}
      items={countries}
      itemRenderer={(country, { handleClick, modifiers }) => (
        <MenuItem
          key={`country-${country}`}
          active={modifiers.active}
          onClick={(e: MouseEvent<HTMLElement>) => {
            if (multi) {
              e.preventDefault()
              onChange(country)
              return
            }
            handleClick(e)
          }}
          text={
            <Flex align="center">
              {multi && <Checkbox checked={itemDisabled && itemDisabled(country)} />}
              {country}
            </Flex>
          }
        />
      )}
      onItemSelect={onChange}
    >
      <Button
        {...buttonProps}
        text={value ? value : btnText || 'Select'}
        rightIconName={!get(buttonProps, 'iconName') && !value ? 'chevron-down' : undefined}
      />
    </CountrySelector>
  )
}

const useCountries = () => {
  const [countries, setCountries] = React.useState<string[]>([])

  React.useEffect(() => {
    api.company.countries().then((countries) => setCountries(countries))
  }, [])
  return countries
}
